import * as S from './AskMeList.styles'
import Feed from './Feed'
import Header from './Header'

const defaultProps = {}
const propTypes = {}

export const AskMeList = props => {
  const { data } = props
  return (
    <S.Container key={data?.name}>
      <Header {...props} />
      <Feed {...props} />
    </S.Container>
  )
}

AskMeList.defaultProps = defaultProps
AskMeList.propTypes = propTypes

export default AskMeList
